import { memeList, type MemeItem } from '@/mocks/wuyi';
import SectionHeading from './SectionHeading';

const colorMap: Record<
  MemeItem['color'],
  { badge: string; line: string; bubble: string }
> = {
  primary: { badge: 'bg-primary-500 text-background-50', line: 'from-primary-500', bubble: 'bg-primary-100 text-primary-700' },
  accent: { badge: 'bg-accent-500 text-background-50', line: 'from-accent-500', bubble: 'bg-accent-100 text-accent-700' },
  secondary: { badge: 'bg-secondary-500 text-background-50', line: 'from-secondary-500', bubble: 'bg-secondary-100 text-secondary-800' },
};

export default function MemeSection() {
  return (
    <section id="memes" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="网络流行 · VIBE CHECK"
          title="热梗"
          accent="盘点"
          desc="假期里被反复玩梗的流行语，懂了这些，才能和群里的小伙伴聊到一块去。"
        />

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {memeList.map((m, idx) => {
            const c = colorMap[m.color];
            return (
              <article
                key={m.id}
                className="group overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-colors hover:border-background-300"
              >
                <div className={`h-1 w-full bg-gradient-to-r ${c.line} to-transparent`}></div>
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={m.image}
                    alt={`热梗 ${m.word}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute left-3 top-3 flex items-center gap-2">
                    <span
                      className={`flex h-7 w-7 items-center justify-center rounded-full font-heading text-sm text-background-50 ${c.badge}`}
                    >
                      {idx + 1}
                    </span>
                    <span className="rounded-full bg-background-950/35 px-2.5 py-0.5 text-xs text-background-50 backdrop-blur-sm">
                      热门梗
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className={`inline-flex items-center gap-2 rounded-full px-3 py-1 font-heading text-lg ${c.bubble}`}>
                    {m.word}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{m.meaning}</p>
                  <p className="mt-3 flex items-center gap-1.5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <i className="ri-message-3-line"></i>
                    {m.source}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}